<!-- Загружает доступные источники и собирает единый каталог интеграций. -->
<template>
  <section class="integration-catalog">
    <BasePageHint>
      Настройте интеграции, чтобы видеть актуальную картину работы компании:
      движение транспорта, документы, сообщения и заправки
    </BasePageHint>

    <BaseLoader v-if="isLoading" />

    <div v-else class="integration-catalog__grid">
      <IntegrationCatalogCard
        v-for="card in cards"
        :key="card.key"
        :card="card"
      />
    </div>
  </section>
</template>

<script>
import { useChatProviderStore } from "@/stores/chatProviderStore";
import { useIntegrationStore } from "@/stores/integrationStore";
import { useTelemetryStore } from "@/stores/telemetryStore";
import { buildIntegrationCatalogCards } from "@/utils/integrationCatalogUtils";

import IntegrationCatalogCard from "@/components/Integration/CatalogCard.vue";

export default {
  name: "IntegrationCatalog",

  components: {
    IntegrationCatalogCard,
  },

  data() {
    return {
      isLoading: true,
      sourceErrors: {
        integrations: false,
        trackers: false,
        chats: false,
      },
    };
  },

  computed: {
    integrationStore() {
      return useIntegrationStore();
    },

    chatProviderStore() {
      return useChatProviderStore();
    },

    telemetryStore() {
      return useTelemetryStore();
    },

    cards() {
      const cards = buildIntegrationCatalogCards({
        integrations: this.integrationStore.integrations,
        trackers: this.telemetryStore.trackers,
        chatProviders: this.chatProviderStore.chatProviders,
      });

      return cards.map((card) => ({
        ...card,
        loadFailed: {
          trackers: this.sourceErrors.trackers,
          saby: this.sourceErrors.integrations,
          chats: this.sourceErrors.chats,
        }[card.key] || false,
      }));
    },
  },

  methods: {
    async loadCatalog() {
      this.isLoading = true;
      const results = await Promise.allSettled([
        this.integrationStore.fetchIntegrations(),
        this.telemetryStore.getTrackersRequest(),
        this.chatProviderStore.fetchChatProviders(),
      ]);
      this.sourceErrors = {
        integrations: results[0].status === "rejected",
        trackers: results[1].status === "rejected",
        chats: results[2].status === "rejected",
      };
      this.isLoading = false;
    },
  },

  async created() {
    await this.loadCatalog();
  },
};
</script>

<style scoped>
.integration-catalog__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 1100px) {
  .integration-catalog__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .integration-catalog__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
    padding: 12px 14px;
  }
}
</style>
